export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-breadcrumbs/index.ts